import React, { useEffect, useState } from "react";

export default function LivePriceBadge({ symbol, suffix = ".NS" }) {
  const [q, setQ] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sym = (symbol || "").trim().toUpperCase();
    if (!sym || sym.length < 2) { setQ(null); return; }
    const fullSym = sym.includes(".") || sym.startsWith("^") ? sym : `${sym}${suffix}`;
    const ctrl = new AbortController();
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const r = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/stock-price?symbol=${encodeURIComponent(fullSym)}`,
          { signal: ctrl.signal },
        );
        const data = await r.json();
        setQ(data);
      } catch { /* ignore */ }
      finally { setLoading(false); }
    }, 400);  // debounce typing
    return () => { ctrl.abort(); clearTimeout(t); };
  }, [symbol, suffix]);

  if (!symbol) return null;
  if (loading) return <div className="mt-1.5 text-xs text-zinc-400 font-mono">Loading price…</div>;
  if (!q || q.error || q.price == null) return (
    <div className="mt-1.5 text-xs text-amber-600" title="Price unavailable for this symbol" data-testid="live-price-badge">
      ⚠ Price unavailable
    </div>
  );
  const positive = (q.change || 0) >= 0;
  const arrow = positive ? "▲" : "▼";
  const color = positive ? "text-emerald-700 bg-emerald-50 border-emerald-200" : "text-rose-700 bg-rose-50 border-rose-200";
  return (
    <div className={`mt-1.5 inline-flex items-center gap-2 px-2 py-1 rounded border text-xs font-mono ${color}`} data-testid="live-price-badge">
      <span className="font-semibold">{q.symbol}</span>
      <span>₹{(q.price).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
      {q.change != null && (
        <span>{arrow} {Math.abs(q.change).toFixed(2)} ({(q.change_pct ?? 0).toFixed(2)}%)</span>
      )}
      <span className="text-zinc-400 text-[10px] ml-1">5-min cache</span>
    </div>
  );
}
